import { getPublicMetaData } from 'pricing-pages-lib/api/PublicMetaDataApi';
import { ACTIVE_CURRENCY_CODE_UPDATED } from './constants/ActionTypes';
import { PUBLIC } from './constants/RequestedDataTypes';
import { FetchCountryActions } from './CountryActions';
import { setPublicFeatureFlags } from './FeatureFlagActions';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
import { FetchPhoneNumbersActions } from './PhoneNumbersActions';
import { FetchPromotionActions } from './PromotionActions';
import { FetchRequiredOnboardingActions } from './RequiredOnboardingActions';
export const FetchPublicMetaDataRequestTypes = createRequestTypes(PUBLIC);
export const FetchPublicMetaDataActions = createRequestActions(FetchPublicMetaDataRequestTypes);

// temp formatting until reponse comes back this way from EE to match with in-app onboarding response
const formatRequiredOnboarding = payload => {
  const formattedObj = {};
  Object.keys(payload).map(apiName => // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  formattedObj[apiName] = {
    apiName,
    onboardingApiName: payload[apiName],
    onboardingRequired: true
  });
  return formattedObj;
};

export const fetchPublicMetaData = () => {
  return dispatch => {
    dispatch(FetchPublicMetaDataActions.request());
    dispatch(FetchPromotionActions.request());
    dispatch(FetchRequiredOnboardingActions.request());
    return getPublicMetaData().then(resp => {
      dispatch(FetchPublicMetaDataActions.receive());
      const {
        country,
        defaultCurrency,
        promotions,
        requiredOnboarding,
        phoneNumbers,
        featureFlags
      } = resp;
      const formattedRequiredOnboarding = formatRequiredOnboarding(requiredOnboarding);
      dispatch(FetchCountryActions.receive({
        country
      }));

      if (defaultCurrency) {
        dispatch({
          type: ACTIVE_CURRENCY_CODE_UPDATED,
          payload: defaultCurrency
        });
      }

      dispatch(FetchPromotionActions.receive(promotions));
      dispatch(FetchRequiredOnboardingActions.receive({
        requiredOnboarding: formattedRequiredOnboarding
      }));
      dispatch(FetchPhoneNumbersActions.receive(phoneNumbers));
      dispatch(setPublicFeatureFlags({
        featureFlags
      }));
    }).catch(error => {
      dispatch(FetchPublicMetaDataActions.failure(error));
      dispatch(FetchPromotionActions.failure(error));
      dispatch(FetchRequiredOnboardingActions.failure(error));
      dispatch(FetchPhoneNumbersActions.failure(error));
      throw error;
    });
  };
};